
      <p-fileUpload id="anexo" accept=".pdf, .jpg, .jpeg, .png, .doc, .docx, .xls, .xlsx" maxFileSize="1024*1024*20" fileLimit="1" (onSelect)="onFileChanged($event)"
      chooseLabel="Anexar" uploadLabel="Enviar" (onBeforeUpload)="onUpload()" [showCancelButton]="false" (onRemove)="onClear()" (onError)="onClear()" contentType>
        <ng-template pTemplate="toolbar" >
          <input *ngIf="hasFile" name="descricao" type="text" pInputText [disabled]="false" i18n-placeholder
                 [(ngModel)]="anexo.descricao" placeholder="Descrição..." style="width: 100%;margin-top: 10px">

          <!--textarea pInputTextarea id="observacao"
                    type="text"
                    i18n-placeholder
                    placeholder="Observação..."
                    [rows]="4"
                    [cols]="100"
                    autoResize="autoResize"
                    name="observacao"></textarea-->
        </ng-template>
      </p-fileUpload>
      <img id="outputTemp" class="hidden">
